import React, { useEffect } from 'react';
import { Container, Table, Row, Col, Card, Navbar, Breadcrumb, Dropdown } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import LoaderSpinner from '../../libreria/LoaderSpinner';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pintaNumero, pintaFecha, pintaPesos, pintaEstado, pintaPeriodo } from '../../libreria/utilidades';
import { getNotasCobro } from '../../redux/notascobroSlice';
import { selectPeriodo } from '../../redux/periodoSlice';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import SearchIcon from '@mui/icons-material/Search';
import SearchById from '../../componentes/SearchById';
import PeriodoDropDown from '../../componentes/PeriodoDropDown';

import './PanelNotasCobro.css';

function PanelNotasCobro() {
  const ROWS_QTTY = 18;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const comunidad = useSelector((store) => store.comunidad);
  const notascobro = useSelector((store) => store.notascobro);
  const periodo = useSelector((store) => store.periodo);
  const { promiseInProgress } = usePromiseTracker({ delay: 0 });

  useEffect(() => {
    const onRender = () => {
      if (comunidad.isSelected) {
        trackPromise(dispatch(getNotasCobro(comunidad.selected.id, periodo.anno, periodo.mes, 0, ROWS_QTTY)));
      }
    };

    onRender();
  }, [comunidad.selected, periodo]);

  function handleNotasCobroSearch(value) {
    navigate(`/notacobro/folio/${Number(value)}`);
  }

  function handleCodigoServicioSearch(value) {
    navigate(`/notacobro/cod-servicio/${Number(value)}`);
  }

  function handlePageClick(data) {
    trackPromise(dispatch(getNotasCobro(comunidad.selected.id, periodo.anno, periodo.mes, data.selected, ROWS_QTTY)));
  }

  function handlePeriodoClick(data) {
    // El cambio de periodo no accede a base de datos, no es necesario usar trackPromise().
    dispatch(selectPeriodo(data));
  }

  return (
    <>
      <Container fluid className='PanelNotasCobro d-flex flex-wrap p-0 shadow-sm'>
        <Navbar bg='white' className='flex-fill border-bottom altura-navbar'>
          <Container fluid className='ms-4'>
            <Breadcrumb className='h4 fw-bold m-0' listProps={{ className: 'm-0' }}>
              <Breadcrumb.Item active className='d-none d-lg-inline text-secondary'>
                Gestión del servicio
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Notas de cobro</Breadcrumb.Item>
            </Breadcrumb>
          </Container>
        </Navbar>
        <Navbar bg='white' className='flex-fill flex-wrap border-bottom justify-content-end'>
          <p className='m-0 me-2 d-none d-md-inline text-nowrap'>Período (mes/año):</p>
          <PeriodoDropDown className='me-2' onSelect={handlePeriodoClick} value={pintaPeriodo(periodo)} />
        </Navbar>
      </Container>
      <Container fluid className='PanelNotasCobro d-flex flex-wrap p-0 shadow-sm'>
        <Navbar bg='warning' className='flex-fill border-bottom altura-navbar'>
          <SearchIcon className='icono-centrado ms-3' />
          <i className='ms-1 fw-bold fst-normal me-1 d-none d-md-inline'>Búsqueda</i>
          <div className='vr mx-2'></div>
          <SearchById placeholder='Folio n.cobr.' btntext='Buscar' onClick={handleNotasCobroSearch} />
          <div className='vr mx-2'></div>
          <p className='m-0 me-2 d-none d-md-inline text-nowrap'>Más notas de cobro:</p>
          <SearchById placeholder='Código.serv' btntext='Buscar' onClick={handleCodigoServicioSearch} />
        </Navbar>
      </Container>
      <Container fluid className='PanelNotasCobro'>
        <Row className='p-2'>
          <Col xs={12} xxl={10} className='p-2'>
            <Card className='shadow-sm'>
              <Card.Header className='d-flex flex-wrap p-0'>
                <Navbar className='flex-fill'>
                  <Card.Title className='fs-4 m-0 ms-3 fw-bold'>
                    Notas de cobro del período: <i className='fst-normal fw-normal text-nowrap'>{pintaPeriodo(periodo)}</i>
                  </Card.Title>
                </Navbar>
                <Navbar className='flex-fill flex-wrap justify-content-end'>
                  <ReactPaginate
                    previousLabel={'«'}
                    nextLabel={'»'}
                    breakLabel={'..'}
                    pageCount={Math.ceil(notascobro.count / ROWS_QTTY)}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={1}
                    onPageChange={handlePageClick}
                    forcePage={notascobro.page}
                    renderOnZeroPageCount={null}
                    containerClassName={'pagination pagination-sm m-0 me-2'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                  />
                </Navbar>
              </Card.Header>
              <LoaderSpinner isLoading={promiseInProgress}>
                <Card.Body>
                  <Table striped hover responsive size='sm' className='h6'>
                    <thead>
                      <tr className='text-center'>
                        <th>Código servicio</th>
                        <th>Depto.</th>
                        <th>Medidor</th>
                        <th>Tipo tarifa</th>
                        <th>Nombre cliente</th>
                        <th>F.emisión</th>
                        <th>F.vencimiento</th>
                        <th>Lectura [kWh]</th>
                        <th>Consumo [kWh]</th>
                        <th>Folio</th>
                        <th>Estado</th>
                        <th>Monto</th>
                        <th>Otros períodos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notascobro.rows.map((notacobro) => (
                        <tr key={notacobro.folio}>
                          <td className='text-center'>{pintaNumero(notacobro.codigo_servicio)}</td>
                          <td className='text-nowrap'>{notacobro.numero_depto}</td>
                          <td className='text-center'>
                            <Link className='text-decoration-none' to={'/medidor/' + notacobro.medidor_id}>
                              {notacobro.medidor_id}
                            </Link>
                          </td>
                          <td className='text-center'>{notacobro.tipo_tarifa}</td>
                          <td className='text-center text-nowrap'>{notacobro.business_partner}</td>
                          <td className='text-center text-nowrap'>{pintaFecha(notacobro.fecha_emision)}</td>
                          <td className='text-center text-nowrap'>{pintaFecha(notacobro.fecha_vencimiento)}</td>
                          <td className='text-end'>{pintaNumero(notacobro.lectura_periodo)}</td>
                          <td className='text-end'>{pintaNumero(notacobro.consumo_periodo)}</td>
                          <td className='text-end'>
                            <Link className='text-decoration-none' to={`/notacobro/${notacobro.folio}`}>
                              {notacobro.folio}
                            </Link>
                          </td>
                          <td className='text-center'>{pintaEstado(notacobro.estado)}</td>
                          <td className='text-end text-nowrap'>
                            {pintaPesos(parseInt(notacobro.monto_total))}
                          </td>
                          <td className='text-end'>
                            <Link to={`/notacobro/cod-servicio/${notacobro.codigo_servicio}`} className='link-primary fw-light text-decoration-none text-nowrap'>
                              Ver notas.<button className='ms-1 button-link'>...</button>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </LoaderSpinner>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PanelNotasCobro;
